// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__32tLS","title":"ClientReferral_title__1AwEk","itemText":"ClientReferral_itemText__22Dlf"};